import { urlResolver } from './url-resolver';

export function getUrl({
  endpoint,
  params,
  payload,
  url,
}: {
  endpoint?: string;
  payload?: Record<string, unknown>;
  params: RequestInit;
  url?: string;
}) {
  const { method } = params;
  const resolvedUrl = urlResolver({ endpoint, payload, url, method });

  return {
    url: resolvedUrl,
    params,
  };
}
